interface ReadOnlyFieldProps {
  label: string
  value: React.ReactNode
  onChange?: () => void
  disabled?: boolean
}

const ReadOnlyField = ({
  label,
  value,
  onChange,
  disabled = false,
}: ReadOnlyFieldProps) => (
  <div className="flex flex-col gap-1">
    <div className="flex items-baseline justify-between gap-2">
      <span className="text-sm font-medium text-doubleNickel-gray-700">
        {label}
      </span>
      {onChange && (
        <button
          type="button"
          onClick={onChange}
          disabled={disabled}
          aria-label={`Change ${label.toLowerCase()}`}
          className="text-xs font-medium text-doubleNickel-brand-500 hover:text-doubleNickel-brand-600 disabled:opacity-50"
        >
          Change
        </button>
      )}
    </div>
    <span className="break-words text-sm text-doubleNickel-gray-900">
      {value}
    </span>
  </div>
)

export default ReadOnlyField
